<div class="height-100 flex-column">
    <div class="grid-container grid-4 items-center">
        <div class="grid-span-1">
            <ui-field iconName="search" [label]="'BUTTONS.SEARCH' | translate">
                <input advizeoInput [clearable]="true" [(ngModel)]="searchText" />
            </ui-field>
        </div>
        <div class="grid-span-2 pt-1">
            @if (enableAllBuildingsNodeSelection()) {
                <div
                    class="all-buildings"
                    [class.is-picked]="pickedClassificationNodeId() === ALL_BUILDINGS_NODE"
                    [class.is-selected]="selectedClassificationNodeGroup() === ALL_BUILDINGS_NODE"
                    [tabindex]="0"
                    (click)="selectTopLevelClassificationNode()"
                    (keydown.enter)="selectTopLevelClassificationNode()"
                >
                    <div class="node-name text-body-bold">{{ ALL_BUILDINGS_NODE | classificationNodeName }}</div>
                    <div class="building-count text-body">
                        ({{
                            'COMPONENTS.MAIN_CLASSIFICATION_NODE_SELECTOR.BUILDING_COUNT'
                                | translate: { buildingCount: (buildingsCount$ | async) || 0 | localnumber }
                        }})
                    </div>
                </div>
            }
            <button
                class="ml-2"
                ui-button
                iconName="folder"
                color="primary"
                buttonStyle="outline"
                type="button"
                (click)="openFavoriteParameterSelectorModal()"
            >
                {{ 'COMPONENTS.MAIN_CLASSIFICATION_NODE_SELECTOR.SAVED_FAVORITES_PERIMETERS' | translate }}
                ({{ favoritePerimeterCount.value() | localnumber }})
            </button>
        </div>
    </div>
    <div class="pt-3 flex-1 flex-row reset-flex-mins">
        <div class="flex-1 pr-5 border-r flex-column reset-flex-mins">
            <div class="title-section text mb-3">{{ 'COMPONENTS.MAIN_CLASSIFICATION_NODE_SELECTOR.CLASSIFICATIONS' | translate }}</div>

            <div #classificationsHorizontalScroll class="classification-nodes-columns flex-1 reset-flex-mins scroll-x">
                @if (isSearching()) {
                    <div
                        #scrollContent
                        class="scroll-y two-thirds-column"
                        id="scrollSearchedClassificationContent"
                        [class.no-element]="searchedClassificationNodes.noData$ | async"
                    >
                        @if ((searchedClassificationNodes.noData$ | async) !== true) {
                            <shared-ui-infinite-scrolling
                                [scrollContent]="scrollContent"
                                (scrolled)="searchedClassificationNodes.loadMore()"
                            >
                                <div class="classification-nodes-column-search">
                                    @for (node of searchedClassificationNodes.content$ | async; track node.classificationNodeId) {
                                        <div
                                            class="classification-node"
                                            [class.is-picked]="node.classificationNodeId === pickedClassificationNodeId()"
                                            [class.is-open]="node.classificationNodeId === openedClassificationNodeSearch()"
                                            [class.is-selected]="node.classificationNodeId === selectedClassificationNodeGroup()"
                                            [tabindex]="0"
                                            (dblclick)="
                                                selectClassificationNode(node);
                                                node.hasSubgroup ? toggleClassificationNodeSearch(node.classificationNodeId) : null
                                            "
                                            (click)="selectClassificationNode(node)"
                                            (keydown.enter)="selectClassificationNode(node)"
                                        >
                                            <div class="classification-node-search-content">
                                                <div class="flex-column width-100">
                                                    <div class="classification-node-search-content">
                                                        <div class="node-name text-body-bold">{{ node.name }}</div>
                                                        <div class="building-count text-body">
                                                            ({{
                                                                'COMPONENTS.MAIN_CLASSIFICATION_NODE_SELECTOR.BUILDING_COUNT'
                                                                    | translate: { buildingCount: node.buildingCount | localnumber }
                                                            }})
                                                        </div>
                                                    </div>
                                                    <div class="text-body classification-node-breadcrumb">
                                                        {{ node.breadcrumb }}
                                                    </div>
                                                </div>
                                                <div>
                                                    @if (node.hasSubgroup) {
                                                        <ui-icon
                                                            size="small"
                                                            boundaries="icon"
                                                            class="cursor-hand"
                                                            [onBackground]="
                                                                node.classificationNodeId === pickedClassificationNodeId()
                                                                    ? { color: 'dark', derivation: 'faded' }
                                                                    : node.classificationNodeId === openedClassificationNodeSearch()
                                                                      ? { color: 'light', derivation: 'highlight' }
                                                                      : { color: 'light', derivation: 'faded' }
                                                            "
                                                            [name]="
                                                                node.classificationNodeId === openedClassificationNodeSearch()
                                                                    ? 'retract-side'
                                                                    : 'expand-side'
                                                            "
                                                            (click)="
                                                                $event.stopPropagation();
                                                                toggleClassificationNodeSearch(node.classificationNodeId)
                                                            "
                                                        />
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                                @if (searchedClassificationNodes.isLoading$ | async) {
                                    <div class="search-loading">
                                        <div class="loading-element width-100">&nbsp;<br />&nbsp;</div>
                                        <div class="loading-element width-100">&nbsp;<br />&nbsp;</div>
                                        <div class="loading-element width-100">&nbsp;<br />&nbsp;</div>
                                        <div class="loading-element width-100">&nbsp;<br />&nbsp;</div>
                                        <div class="loading-element width-100">&nbsp;<br />&nbsp;</div>
                                    </div>
                                }
                            </shared-ui-infinite-scrolling>
                        } @else {
                            <div class="width-100 height-100 flex-row justify-center items-center text-body-bold">
                                {{
                                    (enableBuildingSelection()
                                        ? 'SEARCH.NO_RESULTS'
                                        : 'COMPONENTS.MAIN_CLASSIFICATION_NODE_SELECTOR.NO_SEARCH_ON_BUILDING'
                                    ) | translate
                                }}
                            </div>
                        }
                    </div>
                }
                @if (
                    !(
                        classificationNodeColumns.length === 1 &&
                        !classificationNodeColumns()[0].isLoading &&
                        classificationNodeColumns()[0].nodes.length === 0
                    )
                ) {
                    @for (column of classificationNodeColumns(); track column; let columnIndex = $index) {
                        <div class="classification-nodes-column scroll-y">
                            @if (!column.isLoading) {
                                @if (!column.isError) {
                                    @for (node of column.nodes; track node) {
                                        <div
                                            class="classification-node"
                                            [class.is-picked]="node.classificationNodeId === pickedClassificationNodeId()"
                                            [class.is-open]="node.classificationNodeId === column.openedNode"
                                            [class.is-selected]="node.classificationNodeId === selectedClassificationNodeGroup()"
                                            [tabindex]="0"
                                            (dblclick)="
                                                selectClassificationNode(node);
                                                node.hasSubgroup ? toggleClassificationNode(node.classificationNodeId, columnIndex) : null
                                            "
                                            (click)="selectClassificationNode(node)"
                                            (keydown.enter)="selectClassificationNode(node)"
                                        >
                                            <div class="node-name text-body-bold" ellipsisWithTitleFallback>{{ node.name }}</div>
                                            <div class="flex-row gap-1">
                                                <div class="building-count text-body">
                                                    ({{
                                                        'COMPONENTS.MAIN_CLASSIFICATION_NODE_SELECTOR.BUILDING_COUNT'
                                                            | translate: { buildingCount: node.buildingCount | localnumber }
                                                    }})
                                                </div>
                                                @if (node.hasSubgroup) {
                                                    <ui-icon
                                                        size="small"
                                                        boundaries="icon"
                                                        class="cursor-hand"
                                                        [onBackground]="
                                                            node.classificationNodeId === pickedClassificationNodeId()
                                                                ? { color: 'dark', derivation: 'faded' }
                                                                : node.classificationNodeId === column.openedNode
                                                                  ? { color: 'light', derivation: 'highlight' }
                                                                  : { color: 'light', derivation: 'faded' }
                                                        "
                                                        [name]="
                                                            node.classificationNodeId === column.openedNode ? 'retract-side' : 'expand-side'
                                                        "
                                                        (click)="
                                                            $event.stopPropagation();
                                                            toggleClassificationNode(node.classificationNodeId, columnIndex)
                                                        "
                                                    />
                                                }
                                            </div>
                                        </div>
                                    }
                                } @else {
                                    <div class="flex-row justify-center">
                                        {{ 'COMPONENTS.MAIN_CLASSIFICATION_NODE_SELECTOR.ERROR' | translate }}
                                    </div>
                                }
                            } @else {
                                <div class="loading-element">&nbsp;</div>
                                <div class="loading-element">&nbsp;</div>
                                <div class="loading-element">&nbsp;</div>
                            }
                        </div>
                    }
                } @else {
                    <div class="width-100 height-100 flex-row justify-center items-center text-body-bold">
                        {{ 'COMPONENTS.MAIN_CLASSIFICATION_NODE_SELECTOR.NO_NODES' | translate }}
                    </div>
                }
            </div>
        </div>
        @if (!isSearchingBuilding()) {
            <div class="flex-1 pl-5 flex-column">
                <div class="title-section text mb-3">
                    {{ selectedClassificationNodeGroup() | classificationNodeName }}
                    ({{
                        'COMPONENTS.MAIN_CLASSIFICATION_NODE_SELECTOR.BUILDING_COUNT'
                            | translate: { buildingCount: (buildingsHandler.elementCount$ | async) || 0 | localnumber }
                    }})
                </div>
                <div #scrollContent class="flex-1 reset-flex-mins scroll-y" id="scrollBuildingContent">
                    <shared-ui-infinite-scrolling
                        class="container"
                        [scrollContent]="scrollContent"
                        (scrolled)="buildingsHandler.loadMore()"
                    >
                        <div class="grid-container grid-3 gap-2">
                            @for (building of buildingsHandler.content$ | async; track building.buildingId) {
                                <div
                                    class="building"
                                    [class.is-picked]="building.buildingId === pickedClassificationNodeId()"
                                    [style.pointer-events]="enableBuildingSelection() ? 'auto' : 'none'"
                                    [class.is-disabled]="!enableBuildingSelection()"
                                    [tabindex]="0"
                                    (click)="enableBuildingSelection() ? selectBuilding(building.buildingId) : $event.stopPropagation()"
                                    (keydown.enter)="
                                        enableBuildingSelection() ? selectBuilding(building.buildingId) : $event.stopPropagation()
                                    "
                                >
                                    <div class="text-body-bold building-name">{{ building.name }}</div>
                                    <div class="text-body building-location">{{ building.city }} - {{ building.zipcode }}</div>
                                </div>
                            }
                            @if (buildingsHandler.isLoading$ | async) {
                                <div class="loading-element">&nbsp;<br />&nbsp;</div>
                                <div class="loading-element">&nbsp;<br />&nbsp;</div>
                                <div class="loading-element">&nbsp;<br />&nbsp;</div>
                                <div class="loading-element">&nbsp;<br />&nbsp;</div>
                                <div class="loading-element">&nbsp;<br />&nbsp;</div>
                            }
                        </div>
                    </shared-ui-infinite-scrolling>
                </div>
            </div>
        } @else {
            <div class="flex-1 pl-5 flex-column">
                <div class="title-section text mb-3">
                    {{ 'SEARCH.RESULTS' | translate }} ({{
                        'COMPONENTS.MAIN_CLASSIFICATION_NODE_SELECTOR.BUILDING_COUNT'
                            | translate: { buildingCount: (searchedBuildings.elementCount$ | async) || 0 | localnumber }
                    }})
                </div>
                <div #scrollContent class="flex-1 reset-flex-mins scroll-y" id="scrollSearchedBuildingContent">
                    @if (
                        enableBuildingSelection() &&
                        ((searchedBuildings.status$ | async) === 'ok' || (searchedBuildings.status$ | async) === 'loading')
                    ) {
                        <shared-ui-infinite-scrolling [scrollContent]="scrollContent" (scrolled)="searchedBuildings.loadMore()">
                            <div class="grid-container grid-3 gap-2">
                                @for (building of searchedBuildings.content$ | async; track building.buildingId) {
                                    <div
                                        class="building"
                                        [class.is-picked]="building.buildingId === pickedClassificationNodeId()"
                                        [style.pointer-events]="enableBuildingSelection() ? 'auto' : 'none'"
                                        [class.is-disabled]="!enableBuildingSelection()"
                                        [tabindex]="0"
                                        (click)="enableBuildingSelection() ? selectBuilding(building.buildingId) : $event.stopPropagation()"
                                        (keydown.enter)="
                                            enableBuildingSelection() ? selectBuilding(building.buildingId) : $event.stopPropagation()
                                        "
                                    >
                                        <div class="text-body-bold building-name">{{ building.name }}</div>
                                        <div class="text-body building-location">{{ building.city }} - {{ building.zipcode }}</div>
                                    </div>
                                }
                                @if (searchedBuildings.isLoading$ | async) {
                                    <div class="loading-element">&nbsp;<br />&nbsp;</div>
                                    <div class="loading-element">&nbsp;<br />&nbsp;</div>
                                    <div class="loading-element">&nbsp;<br />&nbsp;</div>
                                    <div class="loading-element">&nbsp;<br />&nbsp;</div>
                                    <div class="loading-element">&nbsp;<br />&nbsp;</div>
                                }
                            </div>
                        </shared-ui-infinite-scrolling>
                    } @else {
                        <div class="width-100 height-100 flex-row justify-center items-center text-body-bold">
                            {{
                                (enableBuildingSelection()
                                    ? 'SEARCH.NO_RESULTS'
                                    : 'COMPONENTS.MAIN_CLASSIFICATION_NODE_SELECTOR.NO_SEARCH_ON_BUILDING'
                                ) | translate
                            }}
                        </div>
                    }
                </div>
            </div>
        }
    </div>
</div>
